import React from 'react'

const Designer: React.FunctionComponent<any> = () => {
  return <div>zeppOs designer page</div>
}

export default Designer
